import * as React from 'react';
/**
 * Context which holds the required helpers needed to build nested navigators.
 */
export const NavigationBuilderContext = /*#__PURE__*/React.createContext({
  onDispatchAction: () => undefined,
  onOptionsChange: () => undefined
});
//# sourceMappingURL=NavigationBuilderContext.js.map